<template>
    <div class="navigation-wrapper">
        <div class="row">
            <div class="col-12">
                <router-link to="/">
                    <img class="img img-logo" src="/_resources/themes/bellstores/javascript/loyalty-program/src/assets/images/logo-bell-buddy-rewards.png" alt="Bell Buddy Rewards Logo" />
                </router-link>
            </div>
        </div>
        <div class="row">
            <div class="col-12">
                <nav class="navigation">
                    <router-link to="/" class="btn btn-primary btn-bellstores home-link">
                        Home
                    </router-link>
                    <router-link to="/profile" class="btn btn-primary btn-bellstores">
                        Profile
                    </router-link>
                    <router-link to="/cards" class="btn btn-primary btn-bellstores">
                        Manage Cards
                    </router-link>
                    <router-link to="/deals" class="btn btn-primary btn-bellstores">
                        Deals
                    </router-link>
                    <router-link to="/redeemed_rewards" class="btn btn-primary btn-bellstores">
                        Redeemed Rewards
                    </router-link>
                    <a href="#" v-on:click="logout" class="btn btn-primary btn-bellstores float-right">Log Out</a>
                </nav>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'navigation',
    dependencies: ['storageService'],
    methods: {
        logout (e) {
            e.preventDefault()
            this.storageService.clearAll()
            this.$router.push({ name: 'Login' })
        }
    }
}
</script>

<style scoped lang="scss">

</style>



// WEBPACK FOOTER //
// src/components/shared/Navigation.vue